import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { AccordionWrapper, AccordionHeader, AccordionContent } from './Accordion.styles';

const Accordion = ({ title, children, startOpen = false }) => {
  const [isOpen, setIsOpen] = useState(startOpen);

  return (
    <AccordionWrapper>
      <AccordionHeader $isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <span>{title}</span>
        <ChevronDown size={24} />
      </AccordionHeader>
      <AccordionContent $isOpen={isOpen}>
        {children}
      </AccordionContent>
    </AccordionWrapper>
  );
};

export default Accordion;